/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import set from 'lodash/set';
import * as types from '../constants/actions';

export const INITIAL_STATE = { loading: false, loaded: false, error: null, data: [] };

export function reducer(state = [], action) {
    const value = state.slice();
    switch (action.type) {
        case `${types.VALIDATE_RESERVATIONS}_START`:
            set(value, `[${action.number}]`, {
                loading: true,
                loaded: false,
                error: null,
                data: [],
            });
            return value;
        case `${types.VALIDATE_RESERVATIONS}_SUCCESS`:
            set(value, `[${action.number}]`, {
                loading: false,
                loaded: true,
                error: null,
                data: action.payload,
            });
            return value;
        case `${types.VALIDATE_RESERVATIONS}_FAILURE`:
            set(value, `[${action.number}]`, {
                loading: false,
                loaded: true,
                error: action.error || action.message,
                data: get(state, `[${action.number}].data`),
            });
            return value;
        case types.VALIDATE_RESERVATIONS_CLEAR:
            value.splice(action.number, 1);
            return value;
        default:
            return state;
    }
}

export const selectors = {
    getValidationProblems: (state) =>
        state.activitypass.validation.map(({ data }) => data),
    getValidationErrors: (state) =>
        state.activitypass.validation.map(({ error }) => error),
};
